import { render, staticRenderFns } from "./choiceAddress.vue?vue&type=template&id=2cc621bf&scoped=true&"
import script from "./choiceAddress.vue?vue&type=script&lang=js&"
export * from "./choiceAddress.vue?vue&type=script&lang=js&"
import style0 from "./choiceAddress.vue?vue&type=style&index=0&id=2cc621bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc621bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cc621bf')) {
      api.createRecord('2cc621bf', component.options)
    } else {
      api.reload('2cc621bf', component.options)
    }
    module.hot.accept("./choiceAddress.vue?vue&type=template&id=2cc621bf&scoped=true&", function () {
      api.rerender('2cc621bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/choiceAddress.vue"
export default component.exports